import React from "react";
import ReactToPrint from "react-to-print";
import Reportview from "./reportList";

class Pdfexport extends React.Component {
  render() {
    return <Reportview list={this.props.list} />;
  }
}
class Test extends React.Component {
  
  render() {
    console.log(this.props.list);
    return <div className="center-align">
        <h4>Workplace Reopening Checklist for COVID -19</h4>
        <h6>Workplace Reopening Checklist for COVID -19 Incomplete</h6>
        <div className="container">
        <table >
          <thead style={{background:'#f5f5f5'}}>
            <th>Score</th>
            <th><div className="row">
                  <div className="col s6">Failed items</div>
                  <div className="col s6">0</div>
                 </div></th>
                 <th><div className="row">
                  <div className="col s6">Actions</div>
                  <div className="col s6">0</div>
                 </div></th>
             <tbody>
                  
                  <tr>
                    <td>Conducted on</td>
                    <td></td>
                    <td>PLT, KHI, Lobo</td>
                  </tr>
                  <tr>
                    <td>Prepared by</td>
                    <td></td>
                    <td>16th Jul, 2020 6:59 PM PKT</td>
                  </tr>
                  <tr>
                    <td>Site</td>
                    <td></td>
                    <td>Khurram Naushad Khan</td>
                  </tr>
               </tbody>    

          </thead>
        
        </table>
        </div>

        <div style={{pageBreakBefore:'always'}} className="container">
          <div style={{background:'#f5f5f5'}}><h4>Workplace Checklist for COVID-19 Preparedness</h4></div>
          <div className="left-align"><h5>About the Business</h5></div>
          <hr></hr>
          <div className="left-align"><p >Business Name</p></div>
          <hr></hr>
          <div className="left-align"><p>Primary Address</p></div>
          <hr></hr>
          <div className="left-align"><p>City, State, Zip Code</p></div>
          <hr></hr>
          <div className="left-align"><p>Business Name</p></div>
          <hr></hr>
          <div className="left-align"><p>Business Name</p></div>
          <hr></hr>
          <div style={{background:'#f5f5f5'}}><h4>Primary Point of Contact</h4></div>
          <div className="left-align"><h5>Primary Point of Contact</h5></div>
          <hr></hr>
          <div className="left-align"><p >Business Name</p></div>
          <hr></hr>
          <div className="left-align"><p>Primary Address</p></div>
          <div className="left-align"><h5>About the Business</h5></div>
          <hr></hr>
          <div className="left-align"><p>Assess who can do their jobs from home. Give those workers the option to do so. </p></div>
          <hr></hr>
          <div className="left-align"><p>Require workers to complete a self‑assessment checklist to ensure they comply with good ergonomic practices  </p></div>
          <hr></hr>
          <div className="left-align"><p>Appoint a contact person in your business that workers can talk to about any concerns.</p></div>
          <hr></hr>
          <div className="left-align"><p>Who is this person?</p></div>
          <hr></hr>
          <br></br>

          <div className="left-align"><p>Set up ways to communicate with workers online and communicate with them daily. </p></div>
          <hr></hr>

          <div  className="left-align"><p>Provide information to workers about the supports available to them, for example through an employee assistance program.
          </p></div>
        </div>
    </div>;
  }
}
class Example extends React.Component {
  render() {
    console.log();
    return (
      <div>
        <ReactToPrint
          trigger={() => {
            return (
              <a className="btn waves-effect waves-light printoutbtn" href="#">
                Export to Pdf
              </a>
            );
          }}
          content={() => this.componentRef}
        />
        <Pdfexport
          list={this.props.list}
          ref={(el) => (this.componentRef = el)}
        />
       <div style={{display:'none'}}> <Test   list={this.props.list} ref={(e2)=> (this.componentRef = e2)} /></div>
      </div>
    );
  }
}

export default Example;
